let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bzp6w")).then(() => parcelRequire('hC70R'));